import { useState } from 'react';
import { SORT_OPTIONS } from 'src/constants/agents.ts';
import { useAgents } from 'src/providers/AgentsProvider.tsx';
import { AgentsTable } from './components/AgentsTable.tsx';
import { Icon } from '@iconify/react';
import { UIInput } from 'src/components/UI/UIInput.tsx';
import { UIButton } from 'src/components/UI/UIButton.tsx';
import { NavLink } from 'react-router-dom';
import { UIDropdownMenu } from 'src/components/UI/UIDropdownMenu.tsx';
import { AgentsBanner } from './components/AgentsBanner.tsx';
import { CircularProgress } from 'src/components/UI/CircularProgress.tsx';
import { UIAlert } from 'src/components/UI/UIAlert.tsx';
import { AgentsPagination } from './components/AgentsPagination.tsx';

export const AgentsPage = () => {
  const { sortState, agentsQueryState } = useAgents();

  const [currentSort, setCurrentSort] = sortState;
  const [search, setSearch] = useState('');

  const { isFetching, data, isError } = agentsQueryState;

  function handleSortSelect(sortOption: (typeof SORT_OPTIONS)[number]) {
    setCurrentSort(sortOption);
  }

  const sortItems = SORT_OPTIONS.map((item) => ({
    content: item.label,
    onClick: () => handleSortSelect(item),
  }));

  if (isFetching || !data)
    return (
      <div className="flex flex-col items-center justify-center">
        <div className="mb-4 h-4 w-4">
          <CircularProgress spinnerSize="full" className="fill-white" />
        </div>
        <span>Loading...</span>
      </div>
    );
  if (isError) return <UIAlert type="error" message="Error while loading agents" />;

  return (
    <div className="flex h-full w-full flex-grow flex-col gap-3 overflow-y-auto">
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <UIDropdownMenu
          items={sortItems}
          button={{
            className: 'flex items-center justify-center gap-2 rounded-xl bg-[#191C1E] px-3 py-1.5',
            content: (
              <>
                <span className="font-regular text-sm">{currentSort.label}</span>
                <Icon icon="fa6-solid:caret-down" />
              </>
            ),
          }}
        />
        <div className="flex flex-col-reverse items-center justify-center gap-3 sm:flex-row">
          <UIInput
            labelStab={false}
            containerClasses="pt-0 pb-0 h-[58px]"
            inputContainerClasses="py-4 px-4"
            name="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search AI Agents"
            startAdornment={
              <div className="-mr-1 flex items-center justify-center opacity-50">
                <Icon icon="fa6-solid:magnifying-glass" />
              </div>
            }
          />
          <NavLink to="/build-ai-agent">
            <UIButton className="mt-auto" size="xl" buttonColor="blue">
              Create AI Agent
              <Icon icon="fa6-solid:circle-arrow-right" className="ml-1" />
            </UIButton>
          </NavLink>
        </div>
      </div>
      <AgentsTable
        agents={
          data?.result.filter(
            (agent) =>
              agent.name.toLowerCase().includes(search.toLowerCase()) ||
              agent.description.toLowerCase().includes(search.toLowerCase()),
          ) || []
        }
      />
      <div className="my-8 flex justify-center">
        <AgentsPagination />
      </div>
      <AgentsBanner />
    </div>
  );
};
